import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ActivityStatsCards from './components/ActivityStatsCards';
import ActivityFilters from './components/ActivityFilters';
import ActivityTable from './components/ActivityTable';
import { useActivityEvents, useActivityStats } from 'hooks/useUserActivity';
import AddEmployer from 'views/admin/employes/AddEmployer';
import AddEnterprise from 'views/admin/enterprises/AddEnterprise';
import AddContract from 'views/admin/employes/AddContract';
import AddRepport from 'views/admin/reports/AddRepport';
import AddTask from 'views/admin/Tasks/AddTask';

const DEFAULT_FILTERS = {
  userId: null,
  entityType: null,
  actionType: null,
  start: null,
  end: null,
};

export default function UserActivityPage() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [page, setPage] = useState(0);
  const [selectedActivityRow, setSelectedActivityRow] = useState(null);

  const handleEntityClick = (row) => setSelectedActivityRow(row);
  const handleCloseEntityModal = () => setSelectedActivityRow(null);
  const limit = 20;

  const { data: eventsData, isLoading: eventsLoading } = useActivityEvents(
    filters,
    page,
    limit
  );

  const { data: stats, isLoading: statsLoading } = useActivityStats(
    filters.start,
    filters.end
  );

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        Activité Utilisateurs
      </Typography>

      <ActivityStatsCards stats={stats} loading={statsLoading} />

      <ActivityFilters filters={filters} onChange={handleFiltersChange} />

      <ActivityTable
        rows={eventsData?.content ?? []}
        loading={eventsLoading}
        page={page}
        totalElements={eventsData?.totalElements ?? 0}
        totalPages={eventsData?.totalPages ?? 0}
        rowsPerPage={limit}
        onPageChange={setPage}
        onEntityClick={handleEntityClick}
      />

      {selectedActivityRow?.entityType === 'EMPLOYER' && (
        <AddEmployer
          open={true}
          handleClose={handleCloseEntityModal}
          handleCloseOnly={handleCloseEntityModal}
          selectedEmployerP={{ id: selectedActivityRow.entityId }}
          get={() => {}}
        />
      )}
      {selectedActivityRow?.entityType === 'ENTERPRISE' && (
        <AddEnterprise
          open={true}
          handleClose={handleCloseEntityModal}
          handleCloseOnly={handleCloseEntityModal}
          selectedEnterpriseP={{ id: selectedActivityRow.entityId }}
          get={() => {}}
        />
      )}
      {selectedActivityRow?.entityType === 'CONTRACT' && (
        <AddContract
          open={true}
          handleClose={handleCloseEntityModal}
          selectedContract={{ id: selectedActivityRow.entityId }}
          selectedEmployer={null}
          get={() => {}}
        />
      )}
      {selectedActivityRow?.entityType === 'REPORT' && (
        <AddRepport
          isOpen={true}
          onClose={handleCloseEntityModal}
          selectedReportP={{ id: selectedActivityRow.entityId }}
          get={() => {}}
        />
      )}
      {selectedActivityRow?.entityType === 'TASK' && (
        <AddTask
          isOpen={true}
          onClose={handleCloseEntityModal}
          selectedTask={{ id: selectedActivityRow.entityId }}
        />
      )}
    </Box>
  );
}
